import type { ReactNode } from "react";

import { PageTitle } from "./PageTitle";
import { ScrollScreen } from "./ScrollScreen";
import { Stack } from "./Stack";

export function ProtectedScreen({
  title,
  subtitle,
  children,
  narrow = false,
}: {
  title: string;
  subtitle?: string;
  children: ReactNode;
  narrow?: boolean;
}) {
  return (
    <ScrollScreen narrow={narrow}>
      <Stack gap="lg">
        <PageTitle title={title} subtitle={subtitle} />
        <Stack gap="lg">{children}</Stack>
      </Stack>
    </ScrollScreen>
  );
}
